export const routes = {
  LOGIN: "login",
  ADMIN: "admin",
  SUBMITTED: "submitted",
  RESPONSE: "response",
  REQUESTS: "requests",
};
